import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import ButtonPill from '../../components/react-button-pill';
import ExpiredEventIcon from '../icons/expired_event';

// CSS
import './index.scss';

const ExpiredEvent = ({goToPrimaryPerformerPage}) => {
  return (
    <section className="ExpiredEvent">
      <ExpiredEventIcon />
      <p className="ExpiredEvent__Message">
        <FormattedMessage
          id="expiredevent.event.message"
          defaultMessage="Sorry, tickets are no longer available
        for this event"
        />
      </p>
      <ButtonPill className="ExpiredEvent__Button" onClick={goToPrimaryPerformerPage}>
        <FormattedMessage id="expiredevent.event.btnmsg" defaultMessage="View Other Dates" />
      </ButtonPill>
    </section>
  );
};

ExpiredEvent.propTypes = {
  goToPrimaryPerformerPage: PropTypes.func.isRequired,
};

export default ExpiredEvent;
